import PropTypes from 'prop-types';

export default {
    involvedUsers: PropTypes.string,
};
